import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const ForClub = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">サシイレをご覧の競技団体の担当者様へ</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <div className="text-center my-3">
                        <img src="/images/img-omoiwo.jpg" alt="想いをカタチに"/>
                    </div>
                    <div>
                        この度はサシイレへご訪問頂きまして有り難うございます。<br/>
                        このサシイレは、日夜練習に励むアスリートを支援するために、OBやファンの方々が「想いをカタチに」変えて応援する、”新しい応援のカタチ”を目指しています。<br/>
                        <br/>
                        私たちはこのサシイレというプラットフォームを大勢の方にご利用頂き、サシイレをいう文化が日本に根付き、アスリートの方々がより競技に集中して取り組むことの出来る未来を目指しています。<br/>
                        <br/>
                        サシイレの受け入れ先として、HPに掲載し、サシイレプラットフォームをご利用になりたいスポーツ団体のご担当者様がいらっしゃいましたら、<Link to="/contact/club">お問い合わせ</Link>よりご連絡ください。<br/>
                        <br/>
                        <br/>
                        <br/>
                        サシイレが日本スポーツ発展の一役を担えれば幸いでございます。
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default ForClub